import React from "react";
import { Box, Typography } from "@mui/material";
import {
  CheckCircleDisabled,
  CheckCircleFailed,
  CheckCircleSuccess,
} from "../assets/CommonIcons";

type PasswordCriteriaKey =
  | "minLength"
  | "hasUppercase"
  | "hasLowercase"
  | "hasNumber"
  | "hasSymbol";

interface Props {
  password: string;
  showValidation?: any;
}

const getPasswordCriteria = (password: string) => ({
  minLength: password.length >= 12,
  hasUppercase: /[A-Z]/.test(password),
  hasLowercase: /[a-z]/.test(password),
  hasNumber: /[0-9]/.test(password),
  hasSymbol: /[~!@#$%^&*\-+?]/.test(password),
});

const criteriaLabels: { key: PasswordCriteriaKey; label: string }[] = [
  { key: "minLength", label: "Minimum twelve characters" },
  { key: "hasUppercase", label: "At least one uppercase letter (A-Z)" },
  { key: "hasLowercase", label: "At least one lowercase letter (a-z)" },
  { key: "hasSymbol", label: "At least one special character (~!@#$%^&*-+?)" },
  { key: "hasNumber", label: "At least one numeric character (0-9)" },
];

const PasswordValidator: React.FC<Props> = ({ password, showValidation }) => {
  const criteria = getPasswordCriteria(password);

  return (
    <Box
      my={1.5}
      sx={{ display: "flex", flexDirection: "column", gap: "12px" }}
    >
      {criteriaLabels.map(({ key, label }) => {
        const matched = criteria[key];
        return (
          <Box display="flex" alignItems="center" key={key} gap={1}>
            {!showValidation ? (
              <CheckCircleDisabled />
            ) : matched ? (
              <CheckCircleSuccess />
            ) : (
              <CheckCircleFailed />
            )}
            <Typography variant="body2">{label}</Typography>
          </Box>
        );
      })}
    </Box>
  );
};

export default PasswordValidator;
